import React, { ReactNode } from 'react'
import { Map as MapComponent } from '@vis.gl/react-google-maps'
import clsx from 'clsx'

type MapProps = {
  cameraRef: {
    current: {
      zoom: number
      center: google.maps.LatLngLiteral
    }
  }
  handleCameraChanged: (event: any) => void
  children?: ReactNode
  isSeparateMap?: boolean
}

const Map = React.memo(({ cameraRef, handleCameraChanged, isSeparateMap, children }: MapProps) => {
  return (
    <MapComponent
      mapId='dashboard-map'
      className={clsx('w-full', isSeparateMap ? 'h-full' : 'h-118')}
      gestureHandling='greedy'
      disableDefaultUI
      reuseMaps
      defaultZoom={cameraRef.current.zoom}
      defaultCenter={cameraRef.current.center}
      onCameraChanged={handleCameraChanged}
    >
      {children}
    </MapComponent>
  )
})

export default Map
